const labdetail = () => {
    $(document).ready(function () {
        if ($(".lab-detail").length) {
            // Khởi tạo Slick slider cho danh sách hình ảnh
            var $slider = $('.img-slider');
            var $counter = $('.item-event div');
            var $prevBtn = $('.item-event .back');
            var $nextBtn = $('.item-event .next');

            if ($slider.length) {
                // Đợi tất cả ảnh load xong trước khi init slick
                var $images = $slider.find('img');
                var imagesLoaded = 0;
                var totalImages = $images.length;
                var sliderInitialized = false;

                function initSlider() {
                    if (sliderInitialized) return;
                    sliderInitialized = true;

                    $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                        var i = (currentSlide ? currentSlide : 0) + 1;
                        $counter.text(i + '/' + slick.slideCount);
                    });

                    $slider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        speed: 500,
                        arrows: true,
                        prevArrow: $prevBtn,
                        nextArrow: $nextBtn,
                        dots: false,
                        adaptiveHeight: false,
                        fade: false
                    });
                }

                if (totalImages === 0) {
                    initSlider();
                } else {
                    $images.each(function() {
                        var $img = $(this);
                        // Nếu ảnh đã load từ cache
                        if (this.complete && this.naturalHeight !== 0) {
                            imagesLoaded++;
                            checkAllLoaded();
                        } else {
                            $img.on('load', function() {
                                imagesLoaded++;
                                checkAllLoaded();
                            }).on('error', function() {
                                // Nếu ảnh lỗi, vẫn tính là đã load
                                imagesLoaded++;
                                checkAllLoaded();
                            });
                        }
                    });

                    function checkAllLoaded() {
                        if (imagesLoaded === totalImages) {
                            initSlider();
                        }
                    }
                }
            }
        }
    });
}

module.exports = labdetail;
